/**
 * Robustly resolves the source for a user's avatar.
 * Handles both Base64 database-stored images and legacy file-path images.
 */
export const getAvatarSrc = (profileImage) => {
    if (!profileImage) return null;

    if (profileImage.startsWith('data:')) {
        return profileImage;
    }

    if (profileImage.startsWith('http')) {
        return profileImage;
    }

    const envUrl = process.env.REACT_APP_API_URL || '';
    const baseUrl = (envUrl ? envUrl.replace('/api', '') : (window.location.origin.includes('localhost') ? 'http://localhost:5000' : window.location.origin)).replace(/\/$/, '');

    return `${baseUrl}${profileImage}`;
};
